import { render } from "./Loader.vue?vue&type=template&id=186682c3&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=186682c3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\Projects\\Commercial\\GEMA\\Ga-East-Municipal-Assembly\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186682c3"]])

export default __exports__